import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "componentEl", "align", "valign", "direction", "margin", "inline", "className", "gap", "colgap", "rowgap", "wrap", "fullWidth", "fullHeight", "border", "componentRef"];
import React from 'react';
import PropTypes from 'prop-types';
import { componentElDefaults, componentElPropTypes } from '../customPropTypes/componentEl';
import { classNamePropTypes, addClassNames } from '../customPropTypes/classNames';
import { addSpacingClasses, marginPropTypes } from '../customPropTypes/spacing';
import { borderPropTypes, addBorderClasses } from '../customPropTypes/border';
import GroupItem from './GroupItem';
import { jsx as _jsx } from "react/jsx-runtime";
function Group(_ref) {
  var children = _ref.children,
    Component = _ref.componentEl,
    align = _ref.align,
    valign = _ref.valign,
    direction = _ref.direction,
    margin = _ref.margin,
    inline = _ref.inline,
    className = _ref.className,
    gap = _ref.gap,
    colgap = _ref.colgap,
    rowgap = _ref.rowgap,
    wrap = _ref.wrap,
    fullWidth = _ref.fullWidth,
    fullHeight = _ref.fullHeight,
    border = _ref.border,
    componentRef = _ref.componentRef,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var cssClasses = ['st_grp', "st_grp--".concat(direction), "st_grp--a-".concat(align), "st_grp--v-".concat(valign)];
  cssClasses = addBorderClasses(border, cssClasses);
  if (gap && !rowgap && !colgap) cssClasses.push("st_grp--g-".concat(gap));
  if (rowgap) cssClasses.push("st_grp--gr-".concat(rowgap));
  if (colgap) cssClasses.push("st_grp--gc-".concat(colgap));
  if (fullWidth) cssClasses.push('st_width--full');
  if (fullHeight) cssClasses.push('st_height--full');
  if (inline) cssClasses.push('st_grp--inline');
  if (wrap) cssClasses.push('st_grp--wrap');
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    margin: margin,
    cssClasses: cssClasses
  });
  return /*#__PURE__*/_jsx(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps, {
    ref: componentRef,
    children: children
  }));
}
process.env.NODE_ENV !== "production" ? Group.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: componentElPropTypes,
  /** ref for element */
  componentRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]),
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /** whether to display flex inline */
  inline: PropTypes.bool,
  /** margin for component, if any */
  margin: marginPropTypes,
  /** direction of items. Row = horizontal, Column = vertical */
  direction: PropTypes.oneOf(['row', 'column', 'row-reverse', 'column-reverse']),
  /** how to align items horizontally */
  align: PropTypes.oneOf(['center', 'start', 'end', 'stretch', 'space-between', 'initial']),
  /** space between items, if any */
  gap: PropTypes.oneOf(['xs', 'sm', 'smd', 'md', 'mlg', 'lg', 'xl', 'none']),
  /** space between columns, if not set via `gap` */
  colgap: PropTypes.oneOf(['xs', 'sm', 'smd', 'md', 'mlg', 'lg', 'xl', 'none']),
  /** space between rows, if not set via `gap` */
  rowgap: PropTypes.oneOf(['xs', 'sm', 'smd', 'md', 'mlg', 'lg', 'xl', 'none']),
  /** how to align items vertically */
  valign: PropTypes.oneOf(['baseline', 'center', 'start', 'end', 'stretch', 'initial']),
  /** only used in row mode. Whether to wrap if not enough horizontal space */
  wrap: PropTypes.bool,
  /** whether component takes up 100% of available width */
  fullWidth: PropTypes.bool,
  /** whether component takes up 100% of available height */
  fullHeight: PropTypes.bool,
  /** optional standard border around component */
  border: borderPropTypes
} : void 0;
Group.defaultProps = {
  componentEl: componentElDefaults,
  inline: false,
  className: null,
  margin: null,
  direction: 'row',
  align: 'start',
  valign: 'center',
  gap: 'mlg',
  wrap: true,
  colgap: null,
  rowgap: null,
  fullWidth: null,
  fullHeight: null,
  border: null,
  componentRef: null
};
Group.Item = GroupItem;
export default Group;